import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalRef, SiModalService } from '@siemens/element-ng/modal';
import { AuthService } from '../../../../auth/services/auth.service';
import type { Card } from '../../../interfaces/ICardItem';
import { TileService } from '../../../services/tile.service';
import { EditTileDialogComponent } from '../../edit-tile-dialog/edit-tile-dialog.component';

@Component({
    selector: 'app-tile-dialog',
    templateUrl: './tile-dialog.component.html',
    imports: [TranslatePipe]
})
export class TileDialogComponent {
    private tileSrv = inject(TileService);
    private modalService = inject(SiModalService);
    private modalRef = inject<ModalRef<unknown, string>>(ModalRef);
    private authService = inject(AuthService);

    tileData = input.required<Card>();

    closeLightBox(status = 'closed'): void {
        this.modalRef.hide(status);
    }

    downloadFile(): void {
        const tileData = this.tileData();

        if (tileData.key) {
            this.tileSrv.readDocument(tileData.key).then((signedfileUrl: string | boolean) => {
                if (typeof signedfileUrl === 'string') {
                    this.triggerBrowserDownload(signedfileUrl);
                }
            });
        }
    }

    isAdmin(): boolean {
        return this.authService.isAdmin();
    }

    editTile(): void {
        const dialogRef = this.modalService.show(
            EditTileDialogComponent,
            {
                inputValues: { data: { mode: 'edit', tileData: this.tileData() } },
                ignoreBackdropClick: false,
                keyboard: true,
                animated: true,
                class: 'modal-lg',
                ariaLabelledBy: 'edit-tile-dialog-title'
            },
            'close'
        );
        // Close detail dialog if tile was deleted
        dialogRef.hidden.subscribe(result => {
            if (result === 'deleted') {
                this.closeDialog();
            }
        });
    }

    closeDialog(): void {
        this.modalRef.hide('close');
    }

    private triggerBrowserDownload(url: string): void {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
